import { useState, useContext } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { FaSave, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/Drivers/DriverSetting/DriverCreateOffer.css";
import DriverSettingsMasterLayout from "../../../layouts/Drivers/DriverSettingsMasterLayout";

const DriverCreateOffer = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const navigate = useNavigate();

  const [discountPercent, setDiscountPercent] = useState("");
  const [description, setDescription] = useState("");
  const [maxUsers, setMaxUsers] = useState("");
  const [validTill, setValidTill] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const isFormValid = discountPercent && description && maxUsers && validTill;

  const handleCreateOffer = () => {
    if (!isFormValid) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("discount_percent", discountPercent);
    formData.append("description", description);
    formData.append("max_users", maxUsers);
    formData.append("valid_till", validTill);
    formData.append("is_active", isActive);

    axios
      .post(`${baseUrl}/general/createOffer`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        setLoading(false);
        console.log(response.data);
        if (response.data.success === true) {
          setDiscountPercent("");
          setDescription("");
          setMaxUsers("");
          setValidTill("");
          setIsActive(true);
          navigate("/driver-offerlist");
        } else {
          alert("Offer create nahi hui. Try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  return (
    <DriverSettingsMasterLayout screenName={"Create New Offer"} centered={true}>
      <div className="driver-create-offer-container">
        <Container className="driver-create-offer-wrapper">
          {/* Discount Percentage */}
          <Form.Group className="mb-3">
            <Form.Label className="driver-create-offer-label">
              Discount Percentage <span className="text-danger">*</span>
            </Form.Label>
            <div className="driver-create-offer-input-group">
              <Form.Control
                type="number"
                placeholder="50"
                value={discountPercent}
                onChange={(e) => setDiscountPercent(e.target.value)}
                className="driver-create-offer-input"
              />
              <span className="driver-create-offer-percent-sign">%</span>
            </div>
            <small className="text-muted">Enter discount between 1% to 50%</small>
          </Form.Group>

          {/* Offer Description */}
          <Form.Group className="mb-3">
            <Form.Label className="driver-create-offer-label">
              Offer Description <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="e.g., Special discount for weekend rides"
              value={description}
              maxLength={200}
              onChange={(e) => setDescription(e.target.value)}
              className="driver-create-offer-textarea"
            />
            <div className="description-footer">
              <span className="char-counter">{description.length}/200 characters</span>
            </div>
          </Form.Group>

          {/* Maximum Users */}
          <Form.Group className="mb-3">
            <Form.Label className="driver-create-offer-label">
              Maximum Users <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              placeholder="3321"
              value={maxUsers}
              onChange={(e) => setMaxUsers(e.target.value)}
              className="driver-create-offer-input"
            />
            <small className="text-muted">How many customers can use this offer</small>
          </Form.Group>

          {/* Valid Until */}
          <Form.Group className="mb-3">
            <Form.Label className="driver-create-offer-label">
              Valid Until <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={validTill}
              onChange={(e) => setValidTill(e.target.value)}
              className="driver-create-offer-input"
            />
            <small className="text-muted">Select expiry date for this offer</small>
          </Form.Group>

          {/* Activate Toggle */}
          <Form.Check
            type="switch"
            id="activate-offer-switch"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            label="Activate this offer immediately"
            className="driver-create-offer-switch mb-4"
          />

          {/* Cancel / Create Buttons */}
          <div className="d-flex gap-2 mb-4">
            <Button
              className="driver-create-offer-cancel-btn flex-fill"
              onClick={() => navigate("/driver-offerlist")}
            >
              <FaTimes className="me-2" /> Cancel
            </Button>
            <Button
              className="driver-create-offer-submit-btn flex-fill"
              onClick={handleCreateOffer}
              disabled={!isFormValid || loading}
            >
              {loading ? (
                <Spinner as="span" animation="border" size="sm" role="status" />
              ) : (
                <>
                  <FaSave className="me-2" /> Create Offer
                </>
              )}
            </Button>
          </div>

          
        </Container>
      </div>
    </DriverSettingsMasterLayout>
  );
};

export default DriverCreateOffer;